import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ApiService } from '../../../../providers/api.service';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { SM_CONSTANTS } from '../../../../shared/constants/sm-constants';
import { SharedService } from '../../../../providers/shared.service';
import { StorageService } from '../../../../providers/storage.service';

@Component({
  selector: 'sm-status-notes',
  templateUrl: './status-notes.component.html',
  styleUrls: ['./status-notes.component.scss']
})
export class StatusNotesComponent implements OnInit, OnDestroy {
  addStatusNotesForm : FormGroup;

  addStatusNotesHash:string = ''

  
  private apiSubscription: Subscription = new Subscription();
  constructor(private sharedService: SharedService,private storageService : StorageService ,public dialog: MatDialogRef<StatusNotesComponent>, private _apiservice: ApiService, private router: Router) { 
    this.addStatusNotesForm = new FormGroup({
     
      'statusNotes' : new FormControl(null,[Validators.required]),
      
  });

 
  }



  ngOnInit(): void {
    
    this.addStatusNotesHash =  this.storageService.getValueFromAppStorage('addStatusNotes')

  // this.apiSubscription = this._apiservice.apiResult.subscribe((data) => {
  //   console.log(data);

  //   // UPDATE_BUSINESS_DOCS_STATUS_RESULT
   
    
   
  // })
  // console.log(this.entityList);


    


    
  }

  addStatusNotes(){
  console.log(this.addStatusNotesForm.value.statusNotes);




    let data = { 
      hashId: this.addStatusNotesHash,
      status_notes: this.addStatusNotesForm.value.statusNotes 
      }
      console.log(data);

this._apiservice.updateBankInfo(data)
this.dialog.close();
setTimeout(() => {
  this.sharedService.sendClickEvent();
}, 2000);

  }


  public closePopup(): void {
    this.dialog.close();
  }

  ngOnDestroy(): void {
    this.apiSubscription.unsubscribe();
  }

}
